import cn from 'classnames'
import React, { ComponentProps } from 'react'

type CurrencyDollarIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function CurrencyDollarIcon(props: CurrencyDollarIconProps) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('CurrencyDollarIcon', className)}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect width="24" height="24" rx="4" fill="#EBF2FE" />
      <path
        d="M8 14.6666C8 16.1393 9.19391 17.3333 10.6667 17.3333H13.3333C14.8061 17.3333 16 16.1393 16 14.6666C16 13.1938 14.8061 11.9999 13.3333 11.9999H10.6667C9.19391 11.9999 8 10.806 8 9.33325C8 7.86049 9.19391 6.66659 10.6667 6.66659H13.3333C14.8061 6.66659 16 7.86049 16 9.33325M12 5.33325V18.6666"
        stroke="#4489F9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
